import { pickRandomFromArray } from "~/solidJs/shared/helpers/mathRandom";

// Lazy initialization to avoid accessing DOM before it's ready
let dom: {
	errorScreen: HTMLDivElement | null;
	errorText: HTMLDivElement | null;
} | null = null;

function getDom() {
	if (!dom) {
		dom = {
			errorScreen: document.querySelector("#error-screen"),
			errorText: document.querySelector("#error-text")
		};
	}
	return dom;
}

export function setErrorScreen(isError: boolean) {
	const elements = getDom();

	if (!elements.errorScreen || !elements.errorText) {
		console.error("Error screen elements not found in DOM");
		return;
	}

	if (isError) {
		elements.errorText.textContent = pickRandomFromArray(arrOfErrorPhrases);
	}

	elements.errorScreen.classList[isError ? "remove" : "add"]("hidden");
}

const arrOfErrorPhrases = [
	"Error: Creative nodes temporarily down. They're busy dreaming up new ideas.",
	"AI taking a break to appreciate some fine art. Back online soon.",
	"Artificial intelligence out to lunch with its human creators. Back in a bit.",
	"Our nodes are currently recharging their batteries and getting inspired by nature.",
	"The creative AI is having a brainstorming session. It'll be back with some new art pieces soon.",
	"AI nodes taking a break to watch a movie. Back in 2 hours... or maybe 3.",
	"Artificial intelligence out to visit an art museum. Back soon with some fresh ideas.",
	"Our nodes are taking a nap. They need to rest after a long day of creating beautiful art.",
	"Our nodes are taking a pottery class. They want to try a new form of art.",
	"The creative nodes are having a group therapy session. They'll be back with a new perspective.",
	"Nodes temporarily offline for a dance party. They're celebrating their latest artistic creation.",
	"Our nodes are currently taking a language class. They want to learn how to express their artistic vision better."
];
